"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./IconMiniBlock.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconMiniBlock = _ref => {
  let {
    content = {},
    largeBlock,
    alignment,
    contentfulId
  } = _ref;
  const {
    text,
    header,
    type,
    backgroundColor,
    color,
    link,
    Link
  } = content;
  const renderHeader = () => {
    if (link) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-icon-mini-block__header-wrapper"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "ter-icon-mini-block__header",
        style: {
          color: color || "#242D2F"
        },
        dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
        "data-sb-field-path": "header"
      }));
    }
    return /*#__PURE__*/_react.default.createElement("h4", {
      className: "ter-icon-mini-block__header",
      style: {
        color: color || "#242D2F"
      },
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
      "data-sb-field-path": "header"
    });
  };
  const componentInner = /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-icon-mini-block__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    sbProps: contentfulId ? {
      "data-sb-field-path": "miniBlockIcon"
    } : null,
    type: type || "ter-icon--enclosed-arrow-right-dark-48px",
    size: "48px",
    color: color || "#242D2F",
    className: "ter-icon-mini-block__icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-icon-mini-block__content-wrapper"
  }, header && renderHeader(), text && (0, _checkForDangerouslySet.checkAndSet)(text, "ter-icon-mini-block", null, color)));
  const renderComponent = () => {
    if (link && link?.url || link && link?.onClick) {
      return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        to: link?.url,
        Link: Link && Link,
        target: "_self",
        onClick: link?.onClick,
        className: `ter-icon-mini-block ${largeBlock ? "ter-icon-mini-block--large" : ""} 
          ${link && link?.url || link && link?.onClick ? "ter-icon-mini-block--link" : ""} 
          ter-icon-mini-block--${alignment ? alignment : "left"}`,
        style: {
          backgroundColor: backgroundColor
        }
      }, componentInner);
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `ter-icon-mini-block ${largeBlock ? "ter-icon-mini-block--large" : ""} 
          ${link && link?.url ? "ter-icon-mini-block--link" : ""} 
          ter-icon-mini-block--${alignment ? alignment : "left"}`,
        style: {
          backgroundColor: backgroundColor
        }
      }, componentInner);
    }
  };
  return renderComponent();
};
IconMiniBlock.defaultProps = {
  alignment: "left",
  largeBlock: false
};
var _default = IconMiniBlock;
exports.default = _default;
IconMiniBlock.propTypes = {
  content: _propTypes.default.shape({
    header: _propTypes.default.string,
    text: _propTypes.default.string,
    type: _propTypes.default.string,
    backgroundColor: _propTypes.default.string,
    color: _propTypes.default.string,
    link: _propTypes.default.shape({
      url: _propTypes.default.string,
      text: _propTypes.default.string
    })
  }),
  alignment: _propTypes.default.string,
  largeBlock: _propTypes.default.bool
};